module.exports = __webpack_public_path__ + "static/img/玩具.e218da1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/模型库/玩具.png
// module id = t9ly
// module chunks = 1